import { render, staticRenderFns } from "./filtriDdt.vue?vue&type=template&id=02ca8845"
import script from "./filtriDdt.vue?vue&type=script&lang=js"
export * from "./filtriDdt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports